var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.7821 5.47393L11.0208 0.712596C10.7303 0.422095 10.2591 0.422095 9.96863 0.712596C9.67807 1.00316 9.67807 1.47417 9.96863 1.76473L13.4599 5.25604H0.743959C0.333115 5.25604 0 5.58916 0 6C0 6.41079 0.333115 6.74396 0.743959 6.74396H13.4599L9.96875 10.2353C9.67819 10.5258 9.67819 10.9968 9.96875 11.2874C10.114 11.4326 10.3044 11.5053 10.4948 11.5053C10.6852 11.5053 10.8756 11.4326 11.0209 11.2874L15.7821 6.52607C16.0727 6.23551 16.0727 5.7645 15.7821 5.47393Z","fill":"white"}));
}

Arrow.defaultProps = {"width":"16","height":"12","viewBox":"0 0 16 12","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
